/**
 * Override mobile notifications styles
 */

import {
	actionsSX,
	alertSX,
	genericAlertSX,
	wishListAlertSX,
} from '@/components/content/Notifications/styles/alert';
import { snackBarSX } from '@/components/content/Notifications/styles/snackbar';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useNotifications } from '@/data/Content/Notifications';
import { mergeSx } from '@/utils/mergeSx';
import { Alert, Snackbar, Stack } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const Notifications: React.FC = () => {
	const { message, clearMessage } = useNotifications();

	const isGenericAlert = message.isGeneric;
	const alertIcon = isGenericAlert || message.showIcon === false ? false : message.icon;
	const isAutoHide = !message.doesNotHide;
	const isWishlist = message.isWishList;
	const hideCloseButton = message.hideCloseButton;
	const id = message.id;
	const wishlistProps = isWishlist
		? { backgroundColorSx: { backgroundColor: 'black' }, actionSX: wishListAlertSX }
		: { backgroundColorSx: {}, actionSX: {} };

	const genericAlertProps = isGenericAlert
		? { autoHideDuration: 5000, onClick: undefined, alertSX: genericAlertSX }
		: { autoHideDuration: 3000, onClick: clearMessage, alertSX };

	return (
		<Snackbar
			open={!!message.text}
			anchorOrigin={message.anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
			ClickAwayListenerProps={{
				onClickAway: clearMessage,
				mouseEvent: 'onMouseDown',
			}}
			sx={snackBarSX}
			onClose={clearMessage}
			autoHideDuration={isAutoHide ? genericAlertProps.autoHideDuration : null}
		>
			<Alert
				severity={message.severity ?? 'info'}
				action={
					!hideCloseButton ? (
						<Stack
							sx={mergeSx(actionsSX, wishlistProps.backgroundColorSx)}
							onClick={genericAlertProps.onClick}
						>
							<DynamicIcon name={MATERIAL_SYMBOL_ICONS.cancel} />
						</Stack>
					) : undefined
				}
				sx={mergeSx(genericAlertProps.alertSX, wishlistProps.actionSX)}
				icon={alertIcon}
				id={id}
			>
				{message.text}
			</Alert>
		</Snackbar>
	);
};
